import React, { useState } from 'react';
import RadarChart from '../Components/RadarChart';
import { Link } from "react-router-dom";
import { Container, Row, Button } from 'react-bootstrap';
import { PDFDownloadLink, BlobProvider } from '@react-pdf/renderer';
import Doc1 from '../Components/Doc1';
import printJS from 'print-js'
import { pdfButtons, choiceData } from '../Data/data';
import Paragraph from '../Components/Paragraph';

const ChoiceReady = (props) => {
  const [image, setImage] = useState('')

  return (
    <Container role="main" className="content" fluid>
      <Row className="justify-content-center m-auto">
          <Row className="choiceChart w-25 p-0">
              <RadarChart all={props.all} setImage={setImage} />
          </Row>
          { 
            image !== '' &&
            <Container className="text-center mb-3">
              <PDFDownloadLink document={<Doc1 all={props.all} image={image} />} fileName="valintani.pdf" >{({ _blob, _url, loading, _error }) =>
                loading ? <Paragraph text="Lataa..." /> : <Button className="secButton m-1">{pdfButtons.download}</Button>
              }</PDFDownloadLink>
              <BlobProvider document={<Doc1 all={props.all} image={image} />} fileName="valintani.pdf" >{({ _blob, url, loading, _error }) =>
                loading ? <Paragraph text="Lataa..." /> : <Button onClick={() => printJS(url)} className="printButton secButton m-1">{pdfButtons.print}</Button>
              }</BlobProvider>
            </Container>
          }
      </Row>
      <Row className="justify-content-center m-auto">
        <Link to={choiceData.links.nextSection} title="Siirry seuraavaan osioon" className="btn mainButton choiceReadyBtn w-25 m-2" >{choiceData.buttons.moveToSection}</Link>
      </Row>
    </Container>
  );
};

export default ChoiceReady;